import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './DetailsSection.module.scss'

type DetailItem = { key: string; label: string; content: string }

export const DetailsSection: React.FC = () => {
    const { t } = useTranslation()
    const items = t('details.items', { returnObjects: true }) as DetailItem[]
    const [openKey, setOpenKey] = React.useState<string | null>(null)

    const toggle = (key: string) => {
        setOpenKey(prev => (prev === key ? null : key))
    }

    return (
        <PageSection
            title={t('details.title')}
            align="start"
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <div className={cls.accordion}>
                {items.map((it) => {
                    const isOpen = openKey === it.key
                    return (
                        <div key={it.key} className={`${cls.item} ${isOpen ? cls.itemOpen : ''}`}>
                            <button
                                type="button"
                                className={cls.trigger}
                                onClick={() => toggle(it.key)}
                                aria-expanded={isOpen}
                            >
                                <span className={cls.triggerLabel}>{it.label}</span>
                                <span className={`${cls.arrow} ${isOpen ? cls.arrowOpen : ''}`}>
                                    ↓
                                </span>
                            </button>
                            {isOpen && (
                                <div className={cls.body}>
                                    <p className={cls.content}>{it.content}</p>
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </PageSection>
    )
}

export default DetailsSection
